import { Component } from '@angular/core';

@Component({
    templateUrl: './bidcalendar-help.component.html',
    standalone: false
})
export class BidCalendarHelpComponent { }
